import React from 'react';
import { FadeIn } from '../ui/FadeIn';
import { SectionLabel } from '../ui/SectionLabel';
import { Link } from 'react-router-dom';

export const About = () => (
  <section id="about" className="py-28 md:py-40 bg-ivory overflow-hidden">
    <div className="container mx-auto px-6 md:px-14">
      <div className="flex flex-col lg:flex-row items-center gap-16 lg:gap-28">
        <div className="w-full lg:w-1/2 flex-shrink-0">
          <FadeIn direction="right">
            <div className="relative">
              <div className="absolute -bottom-6 -right-6 w-full h-full border border-gold/20" />
              <img 
                src="https://res.cloudinary.com/dfg8nrgvf/image/upload/q_auto/f_auto/v1779379498/1_koxp0j.png" 
                alt="Maison De Charm Interior" 
                className="w-full aspect-[4/5] object-cover shadow-2xl relative z-10" 
              />
              <div className="absolute bottom-8 -left-8 bg-wine text-white px-8 py-6 z-20 shadow-xl">
                <p className="font-serif text-2xl mb-1">Est. 2025</p>
                <p className="text-white/60 text-xs tracking-widest uppercase">Amoy Street</p>
              </div>
            </div>
          </FadeIn>
        </div>
        <div className="w-full lg:w-1/2">
          <FadeIn delay={0.2} direction="left">
            <SectionLabel>Our Story</SectionLabel>
            <h2 className="font-serif text-4xl md:text-5xl text-charcoal mb-8 leading-snug">
              A Muslim Owned French Bistro<br />
              <span className="italic text-wine">with a Fine Dining Experience</span>
            </h2>
            <div className="w-10 h-px bg-gold mb-10" />
            <div className="space-y-6 text-charcoal/65 font-light leading-relaxed text-base">
              <p>
                Take a leisurely stroll along the charming shophouses of Amoy Street, developed in the 1830s as part of Sir Stamford Raffles' 1822 master plan for Chinatown. Named after the Chinese port city of Amoy (now Xiamen), the street retains much of its historic character. Today, its beautifully preserved shophouses are home to acclaimed restaurants, boutique offices, and the ever-popular Amoy Street Food Centre.
              </p>
              <p>
                Nestled within this heritage enclave at 85 Amoy St, Singapore 069904, Maison De Charm is strategically located in the very heart of Singapore's financial district — surrounded by major corporate offices, banks, and business towers. It is an ideal destination for executive lunches, corporate dining, and relaxed yet refined gatherings.
              </p>
              <p>
                Maison De Charm is one of Singapore's most authentic Muslim Owned French bistros — offering the warmth and soul of a true Parisian neighbourhood restaurant, elevated with fine dining quality and care. Traditional French dishes are crafted with premium, air-flown ingredients and complemented by a curated selection of non-alcoholic wines, thoughtfully paired to enrich every meal.
              </p>
            </div>
            <div className="mt-12 flex items-center gap-8">
              <Link 
                to="/menu" 
                className="text-xs tracking-[0.2em] uppercase text-charcoal border-b border-gold pb-1 hover:text-wine hover:border-wine transition-colors"
              >
                Explore Our Menu
              </Link>
              <div className="flex items-center gap-3">
                <span className="w-8 h-px bg-gold/40" />
                <span className="text-[10px] tracking-[0.2em] uppercase text-gold font-medium">Muslim Owned</span>
              </div>
            </div>
          </FadeIn>
        </div>
      </div>
    </div>
  </section>
);